import { render } from "./SubscriptionProducts.vue?vue&type=template&id=c0cdbb30&ts=true"
import script from "./SubscriptionProducts.vue?vue&type=script&lang=ts"
export * from "./SubscriptionProducts.vue?vue&type=script&lang=ts"

import "./SubscriptionProducts.vue?vue&type=style&index=0&id=c0cdbb30&lang=css"

import exportComponent from "D:\\YellowBeardProject\\yellowrock\\yellowrockNew\\yellowrocknewshopadmin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__